import { render, staticRenderFns } from "./GroupsAdmin.vue?vue&type=template&id=3c11d02c"
import script from "./GroupsAdmin.js?vue&type=script&lang=js&external"
export * from "./GroupsAdmin.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports